export enum Branch {
  Aalsmeer = 'Aalsmeer',
  Eelde = 'Eelde',
  Naaldwijk = 'Naaldwijk',
  Rijnsburg = 'Rijnsburg',
}
